import { removeTAndTime, removeTAndDateAndSeconds, removeTAndDate, removeSeconds } from '../filters';

const getDateTimeAsIsoDateString = (d) => {
  const dateString = `${d.getFullYear()}-${(`0${d.getMonth() + 1}`).slice(-2)}-${(`0${d.getDate()}`).slice(-2)}`;
  return dateString;
};

const getDateTimeAsIsoTimeString = (d) => {
  const timeString = `${(`0${d.getHours()}`).slice(-2)}:${(`0${d.getMinutes()}`).slice(-2)}:${(`0${d.getSeconds()}`).slice(-2)}`;
  return timeString;
};

const addDays = function (dt, days) {
  const date = new Date(dt.valueOf());
  date.setDate(date.getDate() + days);
  return date;
};

const addMonths = function (dt, months) {
  const date = new Date(dt.valueOf());
  date.setMonth(date.getMonth() + months);
  return date;
};

const getDateTimeLtString = function (date, time) {
  let result = null;
  if (date) {
    const defaultTime = '00:00:00';
    const resultTime = time ?? defaultTime;
    result = `${date}T${resultTime}`;
  }
  return result;
};

const dateTimeHelpers = {
  getNowAsLocalISO() {
    return dateTimeHelpers.dateTimeString(new Date());
  },
  getCurrentDateLt() {
    const now = this.getNowAsLocalISO();
    return removeTAndTime(now);
  },
  getCurrentTimeLt() {
    const now = this.getNowAsLocalISO();
    return removeTAndDateAndSeconds(now);
  },
  getCurrentTimeWithSecondsLt() {
    const now = this.getNowAsLocalISO();
    return removeTAndDate(now);
  },
  getDateStringFromDateTime(dateTimeString) {
    return removeTAndTime(dateTimeString);
  },
  getTimeStringFromDateTime(dateTimeString) {
    return removeTAndDateAndSeconds(dateTimeString);
  },
  getTimeWithSecondsStringFromDateTime(dateTimeString) {
    return removeTAndDate(dateTimeString);
  },
  dateAndTimeLtString(date, time) {
    return getDateTimeLtString(date, time);
  },
  dateTimeAsIsoDateString(x) {
    return getDateTimeAsIsoDateString(x);
  },
  dateTimeAsIsoTimeString(x) {
    return getDateTimeAsIsoTimeString(x);
  },
  dateTimeString(x) {
    const dateString = dateTimeHelpers.dateTimeAsIsoDateString(x);
    const timeString = dateTimeHelpers.dateTimeAsIsoTimeString(x);
    return getDateTimeLtString(dateString, timeString);
  },
  dateTimeStringRemoveSeconds(x) {
    return removeSeconds(x);
  },
  getFileTimestampNow() {
    // return timestamp in format YYYYMMDD_HHmmss
    const d = new Date();
    const year = `${d.getFullYear()}`;
    let month = `${d.getMonth() + 1}`;
    let day = `${d.getDate()}`;
    let hours = `${d.getHours()}`;
    let minutes = `${d.getMinutes()}`;
    let seconds = `${d.getSeconds()}`;

    if (month.length < 2) month = `0${month}`;
    if (day.length < 2) day = `0${day}`;
    if (hours.length < 2) hours = `0${hours}`;
    if (minutes.length < 2) minutes = `0${minutes}`;
    if (seconds.length < 2) seconds = `0${seconds}`;

    return `${year}${month}${day}_${hours}${minutes}${seconds}`;
  },
  firstDayOfThisMonth() {
    const dt = new Date();
    dt.setDate(1);
    return dt;
  },
  firstDayOfLastMonth() {
    const t = this.firstDayOfThisMonth();
    return addMonths(t, -1);
  },
  firstDayOfNextMonth() {
    const t = this.lastDayOfThisMonth();
    return addDays(t, 1);
  },
  lastDayOfThisMonth() {
    const t = this.firstDayOfNextMonth();
    return addDays(t, -1);
  },
  lastDayOfNextMonth() {
    const t = this.firstDayOfThisMonth();
    const firstDayOfNextPlusOneMonth = addMonths(t, 2);
    return addDays(firstDayOfNextPlusOneMonth, -1);
  },
  startOfDay(date) {
    date.setUTCHours(0, 0, 0, 0);
    return date;
  },
  endOfDay(date) {
    date.setUTCHours(23, 59, 59, 999);
    return date;
  },
  startOfToday() {
    return this.startOfDay(new Date());
  },
  endOfToday() {
    return this.endOfDay(new Date());
  }
};

export default dateTimeHelpers;
